import { PostListItem } from "../PostListItem"

import './PostList.css'

export const PostList = ({ posts, deleteItem, onToggleImoprtant, onToggleLiked }) => {
    return (
        <ul className="app-list list-group">
            {
                posts.map(post => (
                    <PostListItem 
                        key={ post.id } 
                        { ...post } 
                        deleteItem={ () => deleteItem(post.id) }
                        onToggleImoprtant={ () => onToggleImoprtant(post.id) }
                        onToggleLiked={ () => onToggleLiked(post.id) }
                    />
                ))
            }
        </ul>
    )
}



